
import { useState, useEffect } from "react";
import { getCategories } from "@/services/promptService";
import type { Category } from "@/services/promptService";

export function useCategories() {
  const [categories, setCategories] = useState<Category[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const loadCategories = async () => {
      setIsLoading(true);
      try {
        const cats = await getCategories();
        console.log('Loaded categories:', cats.length);
        setCategories(cats);
      } catch (err) {
        console.error('Error loading categories:', err);
        setError(err instanceof Error ? err : new Error('Unknown error loading categories'));
      } finally {
        setIsLoading(false);
      }
    };
    
    loadCategories();
  }, []);

  const getValidCategoryRedirect = () => {
    const ideationCategory = categories.find(cat => cat.slug === 'ideation');
    if (ideationCategory) {
      return `/category/${ideationCategory.slug}`;
    }
    
    if (categories.length > 0) {
      return `/category/${categories[0].slug}`;
    }
    
    return '/explore';
  };

  return { 
    categories, 
    isLoading, 
    error,
    getValidCategoryRedirect
  };
}
